module.exports = __webpack_public_path__ + "static/media/termopary7kz.41abfa2c.pdf";